export const IGetIsDownloadingImageUseCaseType = Symbol('IGetIsDownloadingImageUseCase');
